// src/components/common/KittScanner.jsx
import React from 'react';

const KittScanner = ({ isAnimating }) => {
  return (
    <div className="relative w-full h-px my-2 overflow-hidden bg-primary/10">
      {isAnimating && (
        <div 
          className="absolute top-0 w-[30%] h-full animate-kitt-scan-full"
          style={{
            background: `linear-gradient(90deg, 
              transparent 0%, 
              rgba(var(--primary-rgb), 0.3) 30%, 
              rgba(var(--primary-rgb), 1) 50%, 
              rgba(var(--primary-rgb), 0.3) 70%, 
              transparent 100%)`,
            boxShadow: `
              0 0 4px 1px rgba(var(--primary-rgb), 0.6),
              0 0 8px 2px rgba(var(--primary-rgb), 0.3)`,
          }}
        />
      )}
    </div>
  );
};

export default KittScanner;